import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Navigation = () => {
	return (
		<Navbar>
			<NavHeader>
				<NavLink to='/terms'>Terms</NavLink>
				<NavLink to='/privacy'>Privacy</NavLink>
				<NavAnchor href='mailto:whispr-support@swipr.cc'>Contact Us</NavAnchor>
			</NavHeader>
		</Navbar>
	)
}

const Navbar = styled.nav`
	display: flex;
	justify-content: center;
	margin: auto;
	background-color: #063a46;
	position: fixed;
	bottom: 0;
	right: 0;
	left: 0;
`

const NavHeader = styled.div`
	display: flex;
	width: 262px;
	height: 80px;
	justify-content: space-between;
	align-items: center;
`

const NavLink = styled(Link)`
	color: white;
	font-weight: 600;
	text-decoration: none;
	&:hover {
		background: linear-gradient(135deg, #f7c30a 0%, #f78a0a 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
`

const NavAnchor = styled.a`
	color: white;
	text-decoration: none;
	font-weight: 600;
	transition: all 0.3s ease;
	&:hover {
		background: linear-gradient(135deg, #f7c30a 0%, #f78a0a 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
`

export default Navigation
